module.exports = __webpack_public_path__ + "img/emoji_42.b9cde991.png";